module.exports = __webpack_public_path__ + "static/7-f52b94d01e27576f517e86313432b252.jpg";